import { ExclusiveCategoryFilter } from "./ExclusiveCategoryFilter";
// import { EntityListSort } from "./EntityListSort";
import { CategoryFilter } from "./CategoryFilter";
import { EventDateFilter } from "./EventDateFilter";
import { useAppSelector } from "@store/store";
import { selectMenuItem } from "@store/menuItem/menuItemReducer";

import "./EntityListActionBar.css";

const EntityListActionBar = () => {
  const menuItem = useAppSelector(selectMenuItem);

  if (menuItem?.entity === "FeedPost") {
    return <div style={{ height: "4px" }}></div>;
  }

  return (
    <div className="entity-list-action-bar-component">
      <div className="left-actions">
        {/* <EntityListSort /> https://visitwidget.atlassian.net/browse/FRAM1-2960 */}
        <ExclusiveCategoryFilter />
        <EventDateFilter />
      </div>
      <div className="right-actions">
        <CategoryFilter />
      </div>
    </div>
  );
};

export { EntityListActionBar };
